import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomCaption, randomTitle, randomWords, randomWysiwygText } from '../../../utils/dummyData'
import { parseNestedBlocks } from '../../../utils/expandable'
import { linkWrapper } from '../../../utils/link'
import type { ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { textReadMoreBlockClasses, TextReadMoreLayout } from './textReadMoreBlock.layout'
import type { TextReadMoreBlockProps } from './textReadMoreBlock.state'

export const textReadMoreBlock: ModernBlock<TextReadMoreBlockProps, any, DP.TextReadMore> = {
  kind: 'textReadMoreBlock',
  render: (setRootState, rootState, blockIndex, blockProps) =>
    fromJSX(() => {
      return (
        <TextReadMoreLayout.Inner id={`textblock-${blockIndex}`}>
          <TextReadMoreLayout.Content
            label={blockProps.label}
            title={blockProps.title}
            intro={blockProps.intro}
            text={blockProps.text}
            nestedBlocks={blockProps.nestedBlocks}
            toggler={blockProps.primaryAction}
            isOpen={blockProps.isOpen}
            rootState={rootState}
            setRootState={setRootState}
          />
        </TextReadMoreLayout.Inner>
      )
    }),
  adapters: {
    drupal: (dpBlock: DP.TextReadMore, blockIndex: number) => {
      const target = dpBlock.target.type[0].target_id
      if (target != 'text_with_read_more') return undefined
      return {
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : undefined,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value,
        text: dpBlock.target.field_body[0]?.processed,
        label: dpBlock.target.field_label ? dpBlock.target.field_label[0]?.value : undefined,
        intro: dpBlock.target.field_introduction ? dpBlock.target.field_introduction[0]?.value : undefined,
        anchorTitle: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : '',
        inviewState: false,
        isOpen: false,
        primaryAction: {
          openLabel: dpBlock.target.field_read_more_open_label ? dpBlock.target.field_read_more_open_label[0]?.value : '',
          closeLabel: dpBlock.target.field_read_more_close_label ? dpBlock.target.field_read_more_close_label[0]?.value : '',
        },
        nestedBlocks: parseNestedBlocks(dpBlock.target.field_read_more)
      }
    }
  },
  seoEvents: (props, blockIndex) =>
    [
      props.primaryAction
        ? {
            id: `primary-button`,
            event: 'onClick',
            category: 'readmore',
            label: window.location.pathname,
            action: `primary_button_${
              props.isOpen == true ? props.primaryAction.closeLabel : props.primaryAction.openLabel
            }`,
          }
        : undefined,
    ].filter((i) => i != undefined) as SeoEvent[],
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(textReadMoreBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  blockClassName: getClassNameModern(textReadMoreBlockClasses, 'block', 'mb-6'),
  sampleExample: [
    {
      anchorTitle: 'text-readmore-sample-1',
      label: randomWords(),
      title: randomTitle(),
      intro: dummyData.intro,
      text: randomWysiwygText(),
      primaryAction: {
        openLabel: 'Lees meer',
        closeLabel: 'Lees minder',
      },
      isOpen: false,
      nestedBlocks: [
        {
          kind: 'quoteNested',
          design: 'default',
          text: dummyData.quote,
          author: randomWords(),
          index: 'quote-1' },
        {
          kind: 'textNested',
          body: randomWysiwygText(),
          index: 'text-1' },
        {
          index: 'media-1',
          kind: 'mediaNested',
          displayOption: 'content-width',
          type: 'video',
          source: 'YouTube',
          url: dummyData.video,
          caption: randomCaption(),
        },
        {
          kind: 'textNested',
          body: randomWysiwygText(),
          index: 'text-2'
        },
        {
          kind: 'linkListNested',
          items: [
            {
              key: 'll-i1',
              subTitle: randomTitle(),
              link: linkWrapper({ title: randomTitle(), url: 'https://www.hoppinger.com' })
            },
            {
              key: 'll-i2',
              subTitle: randomTitle(),
              link: linkWrapper({ title: randomTitle(), url: 'https://www.viddadigital.com' })
            },
            {
              key: 'll-i3',
              subTitle: '',
              link: linkWrapper({ title: randomTitle(), url: '/' })
            }
          ],
          index: 'text-3'
        },
      ],
    },
  ],
}
